export default __webpack_public_path__ + "static/media/logo_bro.0bb5062b.svg";